import { Alert } from 'api/alerts/alerts.types';

export enum AlertsContextActionType {
  SET_NEW_ALERTS = 'alerts/setNewAlerts',
  SET_ALERTS_COUNT = 'alerts/setAlertsCount',
  SET_ALERTS_INBOX = 'alerts/setAlertsInbox',
  SET_REQUEST_FOR_OFFERS_COUNT = 'alerts/setRequestForOffersCount',
  SET_ORDERS_COUNT = 'alerts/setOrdersCount',
}

export type AlertsContextAction =
  | {
      type: AlertsContextActionType.SET_NEW_ALERTS;
      alertsCount: number;
      requestForOffersCount: number;
      ordersCount: number;
      alertsInbox: Alert[];
    }
  | { type: AlertsContextActionType.SET_ALERTS_COUNT; alertsCount: number }
  | {
      type: AlertsContextActionType.SET_REQUEST_FOR_OFFERS_COUNT;
      requestForOffersCount: number;
    }
  | {
      type: AlertsContextActionType.SET_ORDERS_COUNT;
      ordersCount: number;
    }
  | {
      type: AlertsContextActionType.SET_ALERTS_INBOX;
      alertsInbox: Alert[];
    };

export type AlertsContextState = {
  alertsCount: number;
  requestForOffersCount: number;
  ordersCount: number;
  alertsInbox: Alert[];
};

export type AlertsContextDispatch = (action: AlertsContextAction) => void;

export type AlertsContextType = {
  state: AlertsContextState;
  dispatch: AlertsContextDispatch;
};
